import ContactsMixin from "../../mixins/contacts-mixin";

Vue.component("contacts-list-all-roles", {

    mixins: [ContactsMixin],

    props: ["api", "contactableName", "createModalTitle", "showSendSmsOption"],

    data () {
        return {
            contacts: [],
            landlords: [],
            tenants: [],
            otherContacts: [],
            showArchivedContacts: false,
            currentContact: {},
            isLoadingContacts: true,
            showSMSOption: true
        };
    },

    created () {
        if (this.showSMSOption && this.showSendSmsOption === false) {
            this.showSMSOption = false;
        }
        let self = this;
        Bus.$on("contact-created", function () {
            self.hideContactCreateLinkForm();
            self.fetchContacts();
        });

        Bus.$on("contact-updated", function () {
            self.fetchContacts();
        });

        Bus.$on("contact-deleted", function () {
            self.fetchContacts();
        });

    },

    mounted () {
        this.fetchContacts();
    },

    methods: {
        hideContactEditForm (uid) {

        },

        emailContact (contact) {
            this.$emit("email-contact", contact.id);
        },

        fetchContacts () {

            this.isLoadingContacts = true;
            axios.get(this.api, ({
                params: {
                    archived: this.showArchivedContacts
                }
            })).then(response => {
                this.isLoadingContacts = false;
                this.contacts = response.data;
                this.groupContacts();
            }).catch(() => {
                this.isLoadingContacts = false;
                window.toastr.error("Error retrieving contacts.");
            });
        },

        groupContacts () {
            this.landlords = this.contacts.filter(this.filterLandlords).filter(this.showArchived);
            this.tenants = this.contacts.filter(this.filterTenants).filter(this.showArchived);
            this.otherContacts = this.contacts.filter(this.filterOtherContacts).filter(this.showArchived);
        },

        filterLandlords (contact) {
            return contact.pivot.role.toLowerCase() === "landlord";
        },

        filterTenants (contact) {
            return contact.pivot.role.toLowerCase() === "tenant";
        },

        filterOtherContacts (contact) {
            return contact.pivot.role.toLowerCase() !== "tenant" && contact.pivot.role.toLowerCase() !== "landlord";
        },

        showEmptyView (contactsAr) {
            return contactsAr.length <= 0 && !this.isLoadingContacts;
        },

        contactDetailString (contact) {
            return contact.mobile ? contact.email + " | " + contact.mobile : contact.email;
        },

        addContact (role = "other") {
            this.selectedRole = role;
            this.showContactCreateLinkForm();
        },

        showContactCreateLinkForm () {
            $("#modal-contact-link-form").modal("show");
        },

        hideContactCreateLinkForm () {
            $("#modal-contact-link-form").modal("hide");
        },

        showArchived (contact) {
            if (this.showArchivedContacts) {
                return true;
            } else return contact.pivot.status !== "archived";
        },

        archiveContactButtonText (status) {
            return status === "archived" ? "Unarchive contact for this " + this.contactableName : "Archive contact for this " + this.contactableName;
        },

        onActionClick (action, data, index) {
            switch (action) {
                case "editContact":
                    this.currentContact = data;
                    this.$refs.editContact.toggleContactForm();
                    break;
            }
        },

        makePrimary (contact) {
            App.post("/contacts/" + contact.id + "/primary", new AppForm({
                role: contact.pivot.role,
                contactable: contact.pivot.contactable_type,
                contactable_id: contact.pivot.contactable_id
            })).then(() => {
                toastr.success("New primary " + contact.pivot.role + " contact set");
                this.fetchContacts();
            });
        },

        removeForRole (contact) {
            App.patch("/contacts/" + contact.id + "/remove", new AppForm({
                role: contact.pivot.role,
                contactable: contact.pivot.contactable_type,
                contactable_id: contact.pivot.contactable_id
            })).then(() => {
                toastr.success("Contact Removed");
                this.fetchContacts();
            });
        },

        toggleStatusForRole (contact) {
            App.post("/contacts/" + contact.id + "/update/status", new AppForm({
                role: contact.pivot.role,
                contactable: contact.pivot.contactable_type,
                contactable_id: contact.pivot.contactable_id,
                currentStatus: contact.pivot.status
            })).then(() => {
                toastr.success("Contact Status Updated");
                this.fetchContacts();
            });
        },

        smsContact (contact) {
            Bus.$emit("show-sms-create-form", contact);
        }

    }
});


